export const changeLanguage = () => ({ type: 'CHANGE_LANGUAGE' })
